import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { of } from 'rxjs';
import { CombinedStore } from 'src/app/core/combined.store';
import { dispatchDeclarationFromContext } from '../utils/dispatch-utils';

/**
 * Resolver qui mappe context.declaration → store.declaration.
 *
 * Filet de sécurité pour les cas où la route subscription est activée
 * sans passer par ContextGuard ou RedirectGuard (ex: refresh, accès direct).
 * S'exécute après tous les guards, juste avant l'instanciation du composant.
 */
export const contextDeclarationResolver: ResolveFn<void> = () => {
  const store = inject(CombinedStore);
  const contextDeclaration = store.context().declaration;

  if (contextDeclaration) {
    dispatchDeclarationFromContext(store, contextDeclaration);
  }

  return of(void 0);
};
